import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import LoginPage from './page/LoginPage/LoginPage'
import RegisterPage from './page/RegisterPage/RegisterPage';
import RestorePage from './page/RestorePage/RestorePage';
import AboutProduct from './page/AboutProduct/AboutProduct';
import Dms from './page/Dms';
import Imeis from './page/Imeis'; 
import Users from './page/Users';
import DmDetals from './components/DmDetals/DmDetals';
import Navbar from './components/UI/Navbar/Navbar';
import './App.css';
import { jwtDecode } from 'jwt-decode'; // Добавьте эту библиотеку для декодирования JWT
import React, {useEffect} from 'react';
import { getVerif } from './redux/actions';
import {useDispatch, useSelector} from 'react-redux';
// import axios from 'axios';


// // Функция для проверки токена на сервере
//     const verifyTokenOnServer = async (token) => {
//         try {
//             const token = localStorage.getItem('token');
//             const response = await axios.get('https://dm-control.ru:5000/api/verif',{
//             //params:{userid,userrole},
//             headers:{
//             Authorization: `Bearer ${token}` // Добавляем токен в заголовок
//             },        
//         });
//         console.log("response");
//         console.log(response);
//         return true;
//         } catch (error) {
//             console.error('Token verification failed:', error);
//             return false;
//         }
//     };
// Компонент для проверки аутентификации
// const PrivateRoute = async({ children }) => {
  // const token = localStorage.getItem('token');
  // const navigate = useNavigate();
  // try {
  //   const token = localStorage.getItem('token');
  //   const isTokenValid = await verifyTokenOnServer(token);
  //           if (!isTokenValid) {
  //               localStorage.removeItem('token');
  //               navigate('/');
  //               //dispatch(logOut());
  //               return;
  //           }
  //   console.log("token");
  //   console.log(token);
  //   if (token) {
  //     const decodedToken = jwtDecode(token);
  //     const isExpired = decodedToken.exp * 1000 < Date.now();
  //     console.log("decodedToken");
  //     console.log(decodedToken);
  //     console.log("isExpired");
  //     console.log(isExpired);
  //     if (isExpired) {
  //       localStorage.removeItem('token');
  //       navigate('/');
  //       return;
  //     }
  //     return children;
  //   }
  //   else{
  //     console.log("token nul");
  //     localStorage.removeItem('token');
  //     navigate('/');
  //     return;
  //   } 
  //   navigate('/');
  //   return;
  // } catch (error) {
  //   localStorage.removeItem('token');
  //   navigate('/');
  //   return;
// }
// };

function App() {
  //const dispatch = useDispatch();
  
  // Проверка токена при загрузке приложения
  //useEffect(async() => {
    // const token = localStorage.getItem('token');
    // const isTokenValid = await verifyTokenOnServer(token);
    //         if (!isTokenValid) {
    //             localStorage.removeItem('token');
    //             //dispatch(logOut());
    //             return;
    //         }
    //dispatch(getVerif(token));

  //   if (token) {
  //     try {
  //       const decodedToken = jwtDecode(token);
  //       const isExpired = decodedToken.exp * 1000 < Date.now();
        
  //       if (isExpired) {
  //         localStorage.removeItem('token');
  //       }
  //     } catch (error) {
  //       localStorage.removeItem('token');
  //     }
  //   }
  // }, []);

  return (   
      <Router>
        <div className="App">
          <Navbar />
        <Routes>
          <Route exact path="/" element={<AboutProduct />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/restore" element={<RestorePage />} />
          <Route path="/dms"  element={<Dms />} />
          <Route path="/imeis"  element={<Imeis />} />
          <Route path="/users"  element={<Users />} />
          <Route path="/dmdetal/:id" element={<DmDetals />} />
        </Routes>
        </div>
      </Router>
  );
  // return (   
  //   <Router>
  //     <div className="App">
  //       <Navbar />
  //       <Routes>
  //         <Route exact path="/" element={<AboutProduct />} />
  //         <Route path="/login" element={<LoginPage />} />
  //         <Route path="/register" element={<RegisterPage />} />
  //         <Route path="/restore" element={<RestorePage />} />
          
  //         {/* Защищенные маршруты */}
  //         <Route path="/dms" element={
  //           <PrivateRoute>
  //             <Dms />
  //           </PrivateRoute>
  //         } />
  //         <Route path="/imeis" element={
  //           <PrivateRoute>
  //             <Imeis />
  //           </PrivateRoute>
  //         } />
  //         <Route path="/users" element={
  //           <PrivateRoute>
  //             <Users />
  //           </PrivateRoute>
  //         } />
  //         <Route path="/dmdetal/:id" element={
  //           <PrivateRoute>
  //             <DmDetals />
  //           </PrivateRoute>
  //         } />
  //       </Routes>
  //     </div>
  //   </Router>
  // );
};

export default App;
